module.exports = __webpack_public_path__ + "img/News_item_14.7b113fa5.jpg";